/** Kestly mark (docs/design/brand/logo-mark.svg). Colours follow the theme tokens: ink/primary light, #E7EAF2/#7C84FF dark. Decorative: pair it with visible text. */
export const Logo = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      className="fill-foreground"
      d="M18 14H43C57 30 29 58 43 82H18A8 8 0 0 1 10 74V22A8 8 0 0 1 18 14Z"
    />
    <path
      className="fill-primary"
      d="M53 14H78A8 8 0 0 1 86 22V74A8 8 0 0 1 78 82H53C39 58 67 30 53 14Z"
    />
  </svg>
)
